module.exports = __webpack_public_path__ + "static/media/siddharth-palamaner-trip-02.12c64405.png";